/* DCG V3.1.2 · 21 OCT 2026 · the addendum, item 1 amended (Cole, 21 OCT): the count line says the in-stock part's size as the guard announces it ("Showing 1-60 of 1,943 · 1,120 in stock"), with In Stock Only off and the number exact; not on the count-fail path */
/* DCG V3.1.0 · 17 OCT 2026 · item 1 (D-SP-29 amended, Cole 17 OCT): a failed count call on the whole collection (no filter, no name, no In Stock Only, no price) shows Shopify's exact count as the page prints it (data-dcg-shopify-count) with the full pager; a filtered or searched listing keeps "Showing 1-60" with Previous / Next; and a race put right: both answers of a search in before storepass.js draws its cards no longer lose the line */
/* DCG v2-10-13 · 16 OCT 2026 · item 4b (D-SP-29 amended, LOCKED by Cole 16 OCT): a page whose count request fails (no answer in 8 s, not a 200, no count) and whose search has no count known reads "Showing 1-60" with Previous / Next and no total, in place of standing aside */
/* DCG v2-10-11 · 16 OCT 2026 · item 2 (a D-SP-38 defect): only a search of the listing's own shape is taken (it names a product line and asks for the listing's page size); the header's suggestions, counted by the guard in v2-10-10, no longer take over the line and the pager */
/* DCG v2-10-8 · 15 OCT 2026 · item 1: after a pager press or a sort the visitor chose, the window lands on the count line (one jump, held while the page settles), on every width */
/* DCG v2-10-7 · 14 OCT 2026 · D-SP-30 (count-line rule PROPOSED) · a count that says the page is the whole search ("one page") shows no total and no pager: since about 13:00 on 14 OCT StorePass's count is the page size on every collection over 60 */
/* DCG v2-10-4 · 13 OCT 2026 · stands aside while the collection safety net shows Shopify's listing (D-SP-37, PROPOSED) · v2-9-1: D-SP-28, D-SP-29 · the count line and the pager for StorePass results */
/* =========================================================
   Desert City Games — "Showing 1-60 of 1,960" and the pager (D-SP-29)
   File: assets/dcg-storepass-paging.js

   WHY
   StorePass's own count is right only under 1,000 results. Above that it
   is an estimate (it marks it "1,000+"), a third to nine tenths of the real
   number, and its pager takes its last page from that estimate: on One
   Piece it ends at page 39 of 66 (docs/REPORT-v2-9-1.md, Part 1). So the
   count line and the pager a customer sees are drawn here, from numbers
   that are true, and StorePass's own two are hidden while these are shown.

   WHAT IT SHOWS
   - a line, above and below the results and at the head of the phone
     filter drawer: "Showing 61-120 of 1,960". The first two numbers are
     what is on the page (the page number, the page size, the cards drawn).
   - a pager under the results: previous, the first page, the current page
     and its neighbours, the last page, next.

   WHERE THE TOTAL COMES FROM. Only an exact source is used:
     1. StorePass's own count, when StorePass does not mark it "+" (it is
        exact under 1,000: 30 of 30 searches measured);
     2. Shopify's count of the collection, printed into the page by the
        theme, when the search is the whole collection: no filter, no card
        name, no "In Stock Only", no price range;
     3. the page itself, when it is short: a page with fewer cards than the
        page size is the last one, so the total is known.
   With none of these there is NO total: the line reads "Showing 61-120",
   and the pager has no last page. A guess is never shown.
   Source 2 does not need StorePass's count: when the count call fails it
   still gives the whole collection its total (V3.1.0; COUNT FAILED below).

   ONE PAGE (v2-10-7). When StorePass's count says its answer is one page
   and no more (the count is at most the page size, its pages 1 or none,
   and the page holds no more products than the count), the line reads
   "Showing 1-N" with no total and no pager is drawn, on every StorePass
   path (collections, search results, Advanced Search). Since about 13:00
   on 14 OCT StorePass's count is the page size on every collection over
   60 and page 2 repeats page 1, so "of 60", or "of 45" from a short page,
   was not a total (One Piece singles holds 1,951). Neither Shopify's count
   nor the short page is taken for a total then. The same rule as for a
   count above 1,000, extended. A small search really of one page reads
   "Showing 1-12" too. (StorePass's page answer always says count = its
   own products and pages 1; the count answer, with_count=true, is read.)

   NO TOTAL, STILL PAGES (v2-10-8). In that state page 2 may still hold
   other cards (it does with StorePass's dashboard switch "Use Shopify for
   initial collection results" off). So the pager offers Previous and Next
   only, no page numbers, and the line reads "Showing 61-120": Next while
   the page came back full (60 of 60), none once a page comes back short.
   A short first page has no pager. With a real total nothing changes.

   LANDING (v2-10-8). After a pager press or a sort the visitor chose, the
   window lands on the count line at the top of the results (see land()).

   WHAT IT DOES NOT DO
   It makes no request and builds no card. It reads what the guard
   (assets/dcg-storepass-guard.js) announces about StorePass's own search
   answers, and counts the cards StorePass drew. A page change puts
   page=<n> into the address and tells StorePass, exactly as a filter click
   does (assets/dcg-storepass-filters.js); StorePass does the search.

   StorePass serves nothing past about 10,000 results, so the pager stops
   at the last page it will serve, and says so when the total is larger.

   If this file does not run, StorePass's own count and pager show, as
   before.
   ========================================================= */
(function () {
  'use strict';

  window.DCG = window.DCG || {};
  if (window.DCG.storepassPaging) return;

  const MAX_RESULTS = 10000;                 // StorePass's search answers nothing from this result on
  const RELOAD_PATIENCE = 5000;              // ms to wait for the count of a new page before giving the line up
  const ATTR = 'data-dcg-paging';            // on the results container while our line and pager are shown
  const LINE = 'dcg-count';
  const PAGER = 'dcg-pager';
  const NOTE = 'dcg-pager-note';
  const FOOT = 'dcg-paging-foot';

  const listing = () => document.getElementById('product-listing-container');
  const fmt = n => { try { return Number(n).toLocaleString('en-CA'); } catch (_) { return String(n); } };

  // ── Which request is which ──
  // keys that do not change what a search holds
  const PASSIVE = ['page', 'skip', 'with_count', 'no_track', 'shopify_page_parameters'];
  // keys a search of a whole collection carries with a value
  const PLAIN = ['store_id', 'mongo', 'override_buylist_gt_price', 'product_line', 'sort', 'limit', 'fields', 'convert_to_currency', 'round_price', 'shopify_collection_id'];
  function keyOf(query) {
    return Object.keys(query).filter(k => PASSIVE.indexOf(k) === -1).sort().map(k => k + '=' + query[k]).join('&');
  }
  function pageOf(query) {
    const size = sizeOf(query);
    const p = parseInt(query.page, 10);
    if (p >= 1) return p;
    const skip = parseInt(query.skip, 10);
    if (skip > 0 && size > 0) return Math.floor(skip / size) + 1;
    return 1;
  }
  function sizeOf(query) { const n = parseInt(query.limit, 10); return n > 0 ? n : 0; }
  // The whole collection, nothing narrowing it.
  function wholeCollection(query) {
    if (!/^\d+$/.test(String(query.shopify_collection_id || ''))) return null;
    if (query.product_line && query.product_line !== 'All') return null;
    for (const k of Object.keys(query)) {
      if (PLAIN.indexOf(k) !== -1 || PASSIVE.indexOf(k) !== -1) continue;
      if (String(query[k] === null || query[k] === undefined ? '' : query[k]) !== '') return null;   // a name, a filter, in_stock, a price bound, a tag
    }
    return String(query.shopify_collection_id);
  }

  // ── Shopify's own counts, printed by the theme ──
  // Shopify counts a collection up to 25,000 and prints 25,001 for anything larger (Magic singles):
  // a number over 25,000 is not a count and is not used.
  const SHOPIFY_COUNTS_TO = 25000;
  const usable = n => (typeof n === 'number' && n >= 0 && n <= SHOPIFY_COUNTS_TO) ? n : null;
  function collectionCount(id) {
    try {
      // V3.1.0 (item 1): first the count the results container prints for its own collection, data-dcg-shopify-count
      // (snippets/store-pass-results.liquid), the number the counts suite reads; the layout's DCG.collectionCounts is
      // the same Liquid value (collection.all_products_count), printed by theme.liquid
      const L = listing();
      const own = L ? L.getAttribute('data-dcg-shopify-count') : null;
      if (own !== null && /^\d+$/.test(own) && L.getAttribute('data-collection-id') === id) return usable(Number(own));
      const direct = window.DCG.collectionCounts;
      if (direct && typeof direct[id] === 'number') return usable(direct[id]);
      const el = document.getElementById('dcg-adv-games');          // the Advanced Search page: one entry a game
      if (el) {
        const games = JSON.parse(el.textContent) || [];
        for (let i = 0; i < games.length; i++) if (String(games[i].collection) === id && typeof games[i].count === 'number') return usable(games[i].count);
      }
    } catch (_) {}
    return null;
  }

  // ── What StorePass has answered ──
  // StorePass's listing sends a count request beside every page of products it asks for. Nothing
  // else does (the header's suggestions ask for products alone). So a page of products is the
  // listing's own when a count request for the same search and page has been seen.
  // DCG v2-10-11 (item 2): and only a search of the listing's own shape is taken: it names a
  // product line and asks for the listing's page size (the guard's pageSize(): a limit in the page's
  // address, or search_limit in the settings storepass.js reads; any size while neither is known).
  // In v2-10-10 the guard counted the header's suggestions (name=…&limit=12&sort=Relevance, no
  // product line), and that pair was taken for the listing: "Showing 1-53 of 255" and a pager to 22
  // on Advanced Search after "charizard" in the header (Cowork, 16 OCT 05:50Z). The guard no longer
  // counts them; this is the second lock.
  function listingShaped(query, size) {
    if (!String(query.product_line || '')) return false;
    let own = null;
    try { const g = window.DCG.storepassGuard; own = g && typeof g.pageSize === 'function' ? g.pageSize() : null; } catch (_) { own = null; }
    return !(own > 0) || size === own;
  }
  let drawn = null;                    // { id, key, page, size, products, query }: the listing's last page of products
  let drawnShown = false;              // V3.1.0: that page's line has been on screen (see render)
  let waiting = null;                  // a page of products whose count request has not answered yet
  let reloading = false;               // the listing is fetching: what `drawn` says is about to be out of date
  let reloadingSince = 0;
  const counts = new Map();            // key -> { count, estimate, pages }
  // V3.1.2, the addendum (Cole, 21 OCT): every product shows, in-stock first (the guard's §K). The guard announces the
  // listing's in-stock count (dcg:storepass-instock, for the search storepass.js made with In Stock Only off); an exact
  // one is said on the line: "Showing 1-60 of 1,943 · 1,120 in stock". An estimate (StorePass's above 1,000) is not.
  const inStock = new Map();           // key -> the exact in-stock count, or null
  function onInStock(detail) {
    if (!detail || !detail.query) return;
    remember(inStock, keyOf(detail.query), detail.exact && typeof detail.count === 'number' ? detail.count : null);
    soon();
  }
  const twins = new Set();             // key|page of every count answer seen
  const failed = new Set();            // v2-10-13: key|page of every count request that failed (see COUNT FAILED below)
  function remember(map, k, v) { map.set(k, v); if (map.size > 40) map.delete(map.keys().next().value); }
  function nowDrawn(info) { drawn = info; drawnShown = false; waiting = null; reloading = false; }
  function hold(set, v, most) { set.add(v); if (set.size > most) set.delete(set.values().next().value); }

  // COUNT FAILED (v2-10-13, item 4b; D-SP-29 amended, LOCKED by Cole, 16 OCT 07:20Z). A page's count request that
  // fails (the guard announces it: no answer in 8 s, not a 200, unreadable, refused), or answers with no count, no
  // longer leaves the line to StorePass (which then shows its own, or nothing): the page's own range is shown, with
  // no total, and Previous / Next with no page numbers, as in the one-page state (v2-10-7, v2-10-8): Next while the
  // page came back full. A count already known for the same search (another of its pages) is still used, as before.
  // A count that comes after all (late) puts the line right.
  // V3.1.0 (item 1; Cole, 17 OCT): on the whole collection (nothing narrowing it: no filter, no card name, no In Stock
  // Only, no price) Shopify's exact count as the page prints it is the total, with the full pager, as when StorePass's
  // count is only an estimate (source 2 above). Filtered and searched listings, and a collection whose printed count is
  // not a count (Magic singles, 25,001), keep the page's own range with Previous / Next.
  function onCountFailed(detail) {
    if (!detail || !detail.query || !detail.isCount) return;
    const q = detail.query;
    const size = sizeOf(q);
    if (!size || !listingShaped(q, size)) return;
    const id = keyOf(q) + '|' + pageOf(q);
    hold(failed, id, 80);
    if (waiting && waiting.id === id) nowDrawn(waiting);
    soon();
  }

  function onSearch(detail) {
    if (!detail || !detail.query) return;
    const q = detail.query;
    const size = sizeOf(q);
    if (!size) return;
    if (!listingShaped(q, size)) return;      // v2-10-11 (item 2): the header's suggestions, a theme's own small request
    const key = keyOf(q);
    const id = key + '|' + pageOf(q);
    if (detail.isCount) {
      twins.add(id);
      if (twins.size > 80) twins.delete(twins.values().next().value);
      if (typeof detail.count === 'number') { remember(counts, key, { count: detail.count, estimate: detail.estimate, pages: typeof detail.pages === 'number' ? detail.pages : null }); failed.delete(id); }
      else hold(failed, id, 80);         // v2-10-13 (item 4b): a count answer with no count is a failed count
      if (waiting && waiting.id === id) nowDrawn(waiting);
      keepLanding();                   // v2-10-8: StorePass still answering: the landing watch stays on
    } else {
      // v2-10-8 (item 1): the visitor chose another sort: its first page lands on the count line, as a page does
      if (sortAsked && Date.now() - sortAsked < SORT_PATIENCE && drawn && String(q.sort || '') !== String(drawn.query.sort || '')) moved = true;
      const info = { id: id, key: key, page: pageOf(q), size: size, products: detail.products, query: q };
      // v2-10-13 (item 4b): a count request refused before the page's answer came (a 503 can be quicker) counts too
      if (twins.has(id) || failed.has(id)) nowDrawn(info); else waiting = info;
      keepLanding();
    }
    soon();
  }

  // StorePass's count is exact when it does not mark it as an estimate.
  function exactCount(c) {
    if (!c || typeof c.count !== 'number' || !(c.count >= 0)) return null;
    if (c.estimate === null || c.estimate === undefined) return c.count < 1000 ? c.count : null;
    const text = String(c.estimate);
    if (text.indexOf('+') !== -1) return null;
    return parseInt(text.replace(/[^\d]/g, ''), 10) === c.count ? c.count : null;
  }
  // v2-10-7: StorePass's count says the page is the whole search (see ONE PAGE above)
  function onePage(c, cards, size) {
    return !!c && typeof c.count === 'number' && c.count > 0 && size > 0 && c.count <= size && !(c.pages > 1) && cards <= c.count;
  }

  // ── The numbers for the page on screen ──
  function cardsOnPage(root) {
    const section = root.querySelector('.store-pass-products-section');
    if (!section) return { cards: 0, loading: false };
    return { cards: section.querySelectorAll(':scope > .store-pass-product').length, loading: !!section.querySelector('.store-pass-product-placeholder') };
  }
  function work() {
    const root = listing();
    if (!root || !drawn) return null;
    const on = cardsOnPage(root);
    if (on.loading || reloading || !on.cards) return null;
    const cards = on.cards, size = drawn.size, page = drawn.page;
    const c = counts.get(drawn.key);
    const start = (page - 1) * size + 1, end = start + cards - 1;
    // v2-10-13 (item 4b): the count request failed and no count is known for this search: the page's own range, no
    // total, Previous / Next only (see COUNT FAILED). V3.1.0 (item 1): unless it is the whole collection and the page
    // prints Shopify's count of it: that total, with the full pager (below)
    const countFailed = !c && failed.has(drawn.id);
    const whole = wholeCollection(drawn.query);
    if (countFailed && (whole === null || collectionCount(whole) === null)) { const capF = Math.ceil(MAX_RESULTS / size); return { page: page, size: size, cards: cards, start: start, end: end, total: null, source: 'count failed', pages: null, last: null, hasNext: cards === size && page < capF, capped: page >= capF && cards === size, cap: capF, countFailed: true, numbers: false }; }
    // v2-10-7: StorePass's count says one page and no more: "Showing N-M", no total. v2-10-8 (item 3): the pager is
    // Previous / Next only, with no page numbers; Next while this page came back full, none once a page comes back
    // short. Page 1 short: no pager at all ("Showing 1-37").
    if (onePage(c, cards, size)) { const cap1 = Math.ceil(MAX_RESULTS / size); return { page: page, size: size, cards: cards, start: start, end: end, total: null, source: 'one page', pages: null, last: null, hasNext: cards === size && page < cap1, capped: page >= cap1 && cards === size, cap: cap1, onePage: true, numbers: false, inStock: inStockOf(drawn, cards) }; }
    let total = null, source = null;
    const exact = exactCount(c);
    if (exact !== null) { total = exact; source = 'storepass'; }
    else {
      const n = whole ? collectionCount(whole) : null;
      if (n !== null) { total = n; source = 'shopify'; }
    }
    if (cards < size) { total = end; source = 'last page'; }          // a short page is the last page
    else if (total !== null && end > total) { total = null; source = null; }   // more on the page than the total allows: the total is not right, so none is shown
    const cap = Math.ceil(MAX_RESULTS / size);
    const pages = total !== null ? Math.max(1, Math.ceil(total / size)) : null;
    const last = pages !== null ? Math.min(pages, cap) : null;
    const hasNext = last !== null ? page < last : (cards === size && page < cap);
    // StorePass will serve no further page: said under the pager when the total is larger, or is not
    // known and this is the last page it serves
    const capped = pages !== null ? pages > cap : (page >= cap && cards === size);
    const out = { page: page, size: size, cards: cards, start: start, end: end, total: total, source: source, pages: pages, last: last, hasNext: hasNext, capped: capped, cap: cap };
    if (countFailed) out.countFailed = true;          // V3.1.0 (item 1): the whole collection's total, its count call having failed
    else out.inStock = inStockOf(drawn, total);       // the addendum: the in-stock part, where known exactly
    return out;
  }
  // the addendum: the in-stock count said on the line: In Stock Only off (on, the listing is its in-stock part alone),
  // the number exact, and no more than the total
  function inStockOf(d, total) {
    if (!d || String(d.query.in_stock || '') !== '') return null;
    const n = inStock.has(d.key) ? inStock.get(d.key) : null;
    if (typeof n !== 'number' || n < 0) return null;
    return total !== null && n > total ? null : n;
  }

  // ── Drawing ──
  const make = (tag, cls, attrs) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) Object.keys(attrs).forEach(k => node.setAttribute(k, attrs[k]));
    return node;
  };
  const lineText = w => 'Showing ' + fmt(w.start) + '-' + fmt(w.end) + (w.total !== null ? ' of ' + fmt(w.total) : '') + (typeof w.inStock === 'number' ? ' · ' + fmt(w.inStock) + ' in stock' : '');

  function hrefFor(page) {
    const url = new URL(window.location.href);
    ['skip', 'shopify_page_parameters'].forEach(k => url.searchParams.delete(k));
    if (page > 1) url.searchParams.set('page', String(page)); else url.searchParams.delete('page');
    return url;
  }
  let moved = false;                    // a page was asked for here: when its cards come, the results are brought to the top of the screen
  function go(page) {
    const url = hrefFor(page);
    const api = window.DCG.storepassFilters;
    moved = true;
    if (api && typeof api.navigate === 'function') api.navigate(url, false);
    else window.location.assign(url.toString());
  }
  function pageLink(page, text, label, cls) {
    const a = make('a', cls || '', { href: hrefFor(page).toString(), 'aria-label': label, 'data-dcg-page': String(page) });
    a.textContent = text;
    return a;
  }
  const ARROW = { prev: 'M15 6l-6 6 6 6', next: 'M9 6l6 6-6 6' };
  function step(kind, page, on) {
    const li = make('li', PAGER + '__item ' + PAGER + '__item--step');
    const label = kind === 'prev' ? 'Previous page' : 'Next page';
    const node = on ? make('a', PAGER + '__step', { href: hrefFor(page).toString(), 'aria-label': label, 'data-dcg-page': String(page), rel: kind }) : make('span', PAGER + '__step', { 'aria-label': label, 'aria-disabled': 'true' });
    const word = make('span', PAGER + '__word'); word.textContent = kind === 'prev' ? 'Previous' : 'Next';
    const svg = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + ARROW[kind] + '"></path></svg>';
    if (kind === 'prev') { node.innerHTML = svg; node.appendChild(word); } else { node.appendChild(word); node.insertAdjacentHTML('beforeend', svg); }
    li.appendChild(node);
    return li;
  }
  function numbers(w) {
    const want = [];
    const add = n => { if (n >= 1 && (w.last === null || n <= w.last) && want.indexOf(n) === -1) want.push(n); };
    add(1); add(w.page - 1); add(w.page);
    if (w.last !== null ? w.page + 1 <= w.last : w.hasNext) add(w.page + 1);
    if (w.last !== null) add(w.last);
    return want.sort((a, b) => a - b);
  }
  function buildPager(w) {
    const nav = make('nav', PAGER, { 'aria-label': 'Pages of results' });
    const ul = make('ul', PAGER + '__list');
    ul.appendChild(step('prev', w.page - 1, w.page > 1));
    let before = 0;
    (w.numbers === false ? [] : numbers(w)).forEach(n => {          // v2-10-8: no numbers when StorePass gives no total (item 3)
      if (before && n > before + 1) { const gap = make('li', PAGER + '__item ' + PAGER + '__item--gap', { 'aria-hidden': 'true' }); gap.textContent = '…'; ul.appendChild(gap); }
      const li = make('li', PAGER + '__item');
      if (n === w.page) { const cur = make('span', PAGER + '__page', { 'aria-current': 'page', 'aria-label': 'Page ' + fmt(n) + (w.last !== null ? ' of ' + fmt(w.last) : '') }); cur.textContent = fmt(n); li.appendChild(cur); }
      else li.appendChild(pageLink(n, fmt(n), (n === 1 ? 'First page, page ' : (w.last !== null && n === w.last) ? 'Last page, page ' : 'Page ') + fmt(n), PAGER + '__page'));
      ul.appendChild(li);
      before = n;
    });
    ul.appendChild(make('li', PAGER + '__break', { 'aria-hidden': 'true' }));     // on a phone the page numbers are one row, Previous and Next the row under it
    ul.appendChild(step('next', w.page + 1, w.hasNext));
    nav.appendChild(ul);
    return nav;
  }
  const signature = w => [w.page, w.size, w.cards, w.total, w.last, w.hasNext, w.capped, w.inStock, window.location.search].join('|');

  // Our line before StorePass's count, in two of the three places StorePass writes one: the results
  // bar and the head of the phone filter drawer. Under the results it is in our own foot. (Before, not
  // after: the skin finds the Sort button as the element after StorePass's count.)
  function placeLines(root, text) {
    const theirs = root.querySelectorAll('.store-pass-results-count');
    for (let i = 0; i < theirs.length; i++) {
      const host = theirs[i].parentNode;
      if (!host || !host.closest) continue;
      // the results bar and the head of the phone filter drawer; the one under the results is in our foot
      if (!host.closest('.store-pass-results-header') && !host.closest('.store-pass-side-filters')) continue;
      let ours = theirs[i].previousElementSibling;
      // the one in the results bar is the one a screen reader is told of, and the one that takes the focus after a page change
      if (!ours || !ours.classList || !ours.classList.contains(LINE)) { ours = make('div', LINE, host.closest('.store-pass-results-header') ? { role: 'status', 'aria-live': 'polite', tabindex: '-1' } : {}); host.insertBefore(ours, theirs[i]); }
      if (ours.textContent !== text) ours.textContent = text;
    }
    // the bar has no count node at all in some states: the line still goes at its head
    const bar = root.querySelector('.store-pass-results-header');
    if (bar && !bar.querySelector('.' + LINE)) { const ours = make('div', LINE, { role: 'status', 'aria-live': 'polite', tabindex: '-1' }); ours.textContent = text; bar.insertBefore(ours, bar.firstChild); }
  }
  // Under the results: the line again, the pager, and a note when StorePass cannot serve the whole search.
  let footFor = '';
  function placeFoot(root, w, text) {
    const section = root.querySelector('.store-pass-products-section');
    if (!section || !section.parentNode) return;
    let foot = section.nextElementSibling;
    if (!foot || !foot.classList || !foot.classList.contains(FOOT)) {
      const old = root.querySelector('.' + FOOT); if (old) old.remove();
      foot = make('div', FOOT);
      section.parentNode.insertBefore(foot, section.nextSibling);
      footFor = '';
    }
    const sig = signature(w);
    if (footFor === sig && foot.firstChild) return;
    footFor = sig;
    while (foot.firstChild) foot.removeChild(foot.firstChild);
    const line = make('div', LINE + ' ' + LINE + '--foot'); line.textContent = text; foot.appendChild(line);
    if (w.page > 1 || w.hasNext) foot.appendChild(buildPager(w));
    if (w.capped) { const note = make('p', NOTE); note.textContent = 'These pages list the first ' + fmt(w.cap * w.size) + '. Use a filter or a card name to see the others.'; foot.appendChild(note); }
  }
  function clear(root) {
    if (root.hasAttribute(ATTR)) root.removeAttribute(ATTR);
    root.querySelectorAll('.' + LINE + ', .' + FOOT).forEach(n => n.remove());
    footFor = '';
  }

  // ── Landing (v2-10-8, item 1) ──
  // After a pager press or a change of sort the window lands on the count line ("Showing 61-120 ..."), LAND_GAP
  // below whatever is fixed over the top of the window (the header, slim or whole on a phone). One instant jump,
  // not a smooth scroll: StorePass scrolls the window to the top as its answer comes, the cards are swapped and
  // the phone header changes height, and a smooth scroll started among those ended anywhere (at the pager, seen
  // by Cowork on 15 OCT). For LAND_WATCH ms after it the line is looked at again and the jump made again if
  // something moved it, until the visitor scrolls, taps or presses a key. On a phone the jump goes through
  // DCG.phone.jumpTo (assets/dcg-phone.js), which sets the header for where the page lands.
  // assets/dcg-collection-fallback.js lands its own count line with this too (DCG.storepassPaging.land).
  const LAND_GAP = 12, LAND_WATCH = 3000, LAND_EVERY = 100, LAND_MAX = 12000;
  const INPUTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];
  let landing = null;
  // the bottom of what is fixed or sticky over the top of the window, other than what holds the line itself
  function coverOver(target) {
    let bottom = 0;
    [0.2, 0.5, 0.8].forEach(f => {
      const at = document.elementsFromPoint ? document.elementsFromPoint(Math.round(window.innerWidth * f), 1) : [];
      at.forEach(e => {
        for (let n = e; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          if (n.contains(target)) break;
          const p = window.getComputedStyle(n).position;
          if (p === 'fixed' || p === 'sticky') {
            const r = n.getBoundingClientRect();
            if (r.top <= 1 && r.height < window.innerHeight / 2 && r.bottom > bottom) bottom = r.bottom;
            break;
          }
        }
      });
    });
    return Math.round(bottom);
  }
  function jump(y) {
    const phone = window.DCG.phone;
    if (phone && typeof phone.jumpTo === 'function') { phone.jumpTo(y); return; }
    try { window.scrollTo({ top: Math.max(0, Math.round(y)), left: 0, behavior: 'instant' }); } catch (_) { window.scrollTo(0, Math.max(0, Math.round(y))); }
  }
  function stopLanding() {
    if (!landing) return;
    window.clearInterval(landing.timer);
    INPUTS.forEach(t => window.removeEventListener(t, landing.off, true));
    landing = null;
  }
  // how far the line is from where it should be, in px (0: landed)
  function landOnce(target) {
    if (!target || !target.isConnected) return 0;
    const off = target.getBoundingClientRect().top - (coverOver(target) + LAND_GAP);
    if (Math.abs(off) > 2) jump((window.scrollY || 0) + off);
    return off;
  }
  function land(target) {
    stopLanding();
    if (!target) return;
    try {
      // twice at once: the first jump can change the header (whole or slim on a phone), and so where the line should be
      landOnce(target); landOnce(target);
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    } catch (_) { return; }
    const off = () => stopLanding();
    const start = Date.now();
    landing = { off: off, until: start + LAND_WATCH, max: start + LAND_MAX, height: document.documentElement.scrollHeight, timer: null };
    landing.timer = window.setInterval(() => {
      try {
        if (!landing || Date.now() > landing.until || !target.isConnected) { stopLanding(); return; }
        // the page still changing (cards, pictures, StorePass's own header) keeps the watch on; so does a jump made again
        const h = document.documentElement.scrollHeight;
        if (h !== landing.height) { landing.height = h; keepLanding(); }
        if (Math.abs(landOnce(target)) > 2) keepLanding();
      } catch (_) { stopLanding(); }
    }, LAND_EVERY);
    INPUTS.forEach(t => window.addEventListener(t, off, { capture: true, passive: true }));
  }
  // (v2-10-8, second run on the draft) the watch lasts LAND_WATCH after the last thing that moved the page: StorePass
  // put the window at the top again about 9 s after a sort at 1440px, after a fixed 3 s watch had ended. Never past
  // LAND_MAX, and the visitor's own scroll, tap or key always ends it.
  function keepLanding() { if (landing) landing.until = Math.min(landing.max, Date.now() + LAND_WATCH); }

  let current = null;
  function render() {
    const root = listing();
    if (!root) return;
    // DCG v2-10-4 (D-SP-37): while the collection safety net shows Shopify's own listing
    // (assets/dcg-collection-fallback.js; [data-dcg-fallback] on the results container) the
    // count line and the pager on the page are its own, with Shopify's count. They are not
    // this file's to draw or to take away: StorePass has drawn no card.
    if (root.hasAttribute('data-dcg-fallback')) { current = null; moved = false; return; }   // (v2-10-8: the net lands its own page)
    const on = cardsOnPage(root);
    // StorePass has emptied its results to fetch: the line on screen is about the page before.
    // V3.1.0: only once the page `drawn` is about has been on screen. Placeholders still showing after both answers of a
    // new search have come are that search's own: storepass.js has not drawn its cards yet. Until V3.1.0 they were taken
    // for yet another search, the line was held, and given up 5 s later, StorePass's own count showing (the counts
    // suite's part "countfail" on the draft, 17 OCT 02:09: the count answered at once, then the page's answer, then the
    // cards; tests/guard/paging-test.js F8, F9).
    if (on.loading && drawn && drawnShown && !reloading) { reloading = true; reloadingSince = Date.now(); }
    const w = work();
    if (!w) {
      // Nothing true to say (no results), or not yet (loading; or the new cards are drawn and their
      // count has not come). While it loads the last line is left where it is, so the bar does not
      // jump. If the count does not come in a few seconds the line would be about another page:
      // ours is taken away and StorePass's own shows.
      const late = reloading && !on.loading && Date.now() - reloadingSince > RELOAD_PATIENCE;
      if (late) reloading = false;
      if ((!on.loading && !reloading) || late) { clear(root); current = null; if (late) drawn = null; }
      else if (reloading && !on.loading) window.setTimeout(soon, 600);       // look again: the count may simply be late
      return;
    }
    current = w;
    drawnShown = true;
    const text = lineText(w);
    placeLines(root, text);
    placeFoot(root, w, text);
    if (!root.hasAttribute(ATTR)) root.setAttribute(ATTR, '');
    if (moved) {
      moved = false;
      // the new page starts at its count line, at the top of the results, under whatever header is on screen
      const bar = root.querySelector('.store-pass-results-header') || root;
      land(bar.querySelector('.' + LINE) || bar);
    }
    try { document.dispatchEvent(new CustomEvent('dcg:storepass-paging', { detail: Object.assign({}, w) })); } catch (_) {}
  }

  let queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; try { render(); } catch (_) { /* never into StorePass */ } }, 30);
  }

  // v2-10-8 (item 1): a choice in StorePass's sort menu (its button .store-pass-sort, the choices links beside it).
  // Only a sort the visitor chose lands the page: a search the page makes by itself never moves the window.
  const SORT_PATIENCE = 8000;
  let sortAsked = 0;
  function onSortChoice(e) {
    const a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a || a.closest('.' + PAGER)) return;
    for (let n = a.parentElement, i = 0; n && i < 4; n = n.parentElement, i++) {
      if (n.querySelector && n.querySelector('.store-pass-sort')) { sortAsked = Date.now(); return; }
    }
  }
  function onClick(e) {
    const a = e.target && e.target.closest ? e.target.closest('.' + PAGER + ' a[data-dcg-page]') : null;
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;      // a new tab or window: the link itself
    const page = parseInt(a.getAttribute('data-dcg-page'), 10);
    if (!(page >= 1)) return;
    e.preventDefault();
    go(page);
  }

  function start() {
    const root = listing();
    if (!root) return;
    document.addEventListener('dcg:storepass-search', e => { try { onSearch(e && e.detail); } catch (_) {} });
    document.addEventListener('dcg:storepass-search-failed', e => { try { onCountFailed(e && e.detail); } catch (_) {} });   // v2-10-13 (item 4b)
    document.addEventListener('dcg:storepass-instock', e => { try { onInStock(e && e.detail); } catch (_) {} });          // V3.1.2, the addendum
    root.addEventListener('click', onClick);
    root.addEventListener('click', e => { try { onSortChoice(e); } catch (_) {} }, true);       // before StorePass's own handler
    if (typeof MutationObserver !== 'undefined') new MutationObserver(soon).observe(root, { childList: true, subtree: true });
    window.addEventListener('popstate', soon);
  }

  window.DCG.storepassPaging = {
    state: () => (current ? Object.assign({}, current) : null),
    text: () => (current ? lineText(current) : ''),
    go: page => go(page),
    land: target => land(target),                       // v2-10-8: used by assets/dcg-collection-fallback.js
    sortAskedAt: () => sortAsked,                       // v2-10-8: when the visitor last chose a sort (0: not lately)
    _exactCount: exactCount,
    _onePage: onePage,
    _wholeCollection: wholeCollection
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { try { start(); } catch (_) {} });
  else { try { start(); } catch (_) {} }
})();
